import React from "react";
import PropTypes from "prop-types";
import { createPortal } from "react-dom";
import styled from "styled-components";

// Style
const Overlay = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: black;

  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 5;
`;

const ModalWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  margin: auto;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;

  overflow-y: scroll;
`;

//! Main Component
const Modal = ({ children, onClose }) => {
  const closeOnOverlay = (e) => {
    // console.log('CLICKED ON MODAL');
    // console.log('DATASET', e.target);
    if (e.target.dataset.id === "modalWrapper") onClose();
    return;
  };

  return createPortal(
    <Overlay>
      <ModalWrapper onClick={(e) => closeOnOverlay(e)} data-id="modalWrapper">
        {children}
      </ModalWrapper>
    </Overlay>,
    document.getElementById("modal")
  );
};

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default Modal;
